module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/~/_core-js@2.5.1@core-js/library/modules/_iter-step.js
// module id = 540
// module chunks = 0 1